import React, { useState } from 'react';
import Webcam from 'react-webcam';
import {QrReader} from "react-qr-reader";


const BarcodeScanner = () => {
    const [result, setResult] = useState('');

    // Webcam callback when a frame is captured
    const handleCapture = (dataUri) => {
        console.log(dataUri)

        // if (dataUri) {
        //     setResult(dataUri);
        // }
    };

    // QR code reader callback when a QR code is detected
    const handleScan = (data) => {
        console.log(data)
        if (data) {
            setResult(data);
        }
    };

    // QR code reader error callback
    const handleError = (error) => {
        console.log(error)
        console.error(error);
    };

    return (
        <div>
            {/* Webcam component */}
            <QrReader
                audio={true}
                height={240}
                width={640}
                constraints={{ facingMode: 'environment' }}
                onResult={(dataUri) => handleCapture(dataUri)}
            />

            {/* QR code reader component */}


            {/* Display the result */}
            {result && <p>Result: {result}</p>}
        </div>
    );
};

export default BarcodeScanner;
